import { sendDelete } from 'helpers/axios';

export const apiDeleteMemberOutOfGroup = (params) => sendDelete(`api/group-role/user`, params);